var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginSimmerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M5 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 18V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h4.5a2.5 2.5 0 1 0 5 0H19q.824 0 1.413.587Q21 4.176 21 5v4a2.5 2.5 0 1 0 0 5v4q0 .824-.587 1.413A1.93 1.93 0 0 1 19 20h-4.5a2.5 2.5 0 1 1-5 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M7.968 5H5.001L5 17.998l6.5.002v2a.5.5 0 1 0 1 0v-2h6.497L19 15.531l-.156-.08a4.5 4.5 0 0 1-2.34-3.74L16.5 11.5c0-1.704.947-3.187 2.344-3.95L19 7.467V5.002L16.031 5l-.08.156a4.5 4.5 0 0 1-3.74 2.34L12 7.5a4.5 4.5 0 0 1-3.95-2.344z"
}))));
export default SvgPluginSimmerIcon;